(function () {
    'use strict';

    angular
        .module('auditMandateModule', ['services.authenticatedUser',
                                       'services.historyCtxt',
                                       'governanceProcessModule']);
})();
